import React from 'react';
import { FiStar, FiAward, FiClock } from 'react-icons/fi';
import { courses } from '../data/therapists';
import { useTranslation, useLocalizedData } from '../i18n';
import { FILE_BASE_URL } from '../utils/api';
import './TherapistCard.css';

function TherapistCard({ therapist, selected, onClick, showDetails }) {
  const { t } = useTranslation();
  const { localize } = useLocalizedData();

  const specialtyNames = therapist.specialties.map((s) => {
    const course = courses.find((c) => c.id === s);
    return course ? localize(course.name) : s;
  });

  const initials = therapist.name.charAt(0).toUpperCase();

  return (
    <div
      className={`therapist-card ${selected ? 'selected' : ''} ${showDetails ? 'detailed' : ''}`}
      onClick={() => onClick && onClick(therapist)}
    >
      <div className="therapist-photo">
        {therapist.photo ? (
          <img className="therapist-avatar-img" src={`${FILE_BASE_URL}/${therapist.photo}`} alt={therapist.name} loading="lazy" />
        ) : (
          <div className="therapist-avatar">{initials}</div>
        )}
      </div>

      <div className="therapist-info">
        <h3 className="therapist-name">
          {localize(therapist.nameKo)} <span className="therapist-name-en">({therapist.name})</span>
        </h3>

        <div className="therapist-meta">
          <span className="meta-item">
            <FiStar className="meta-icon star" />
            {therapist.rating}
          </span>
          <span className="meta-item">
            <FiClock className="meta-icon" />
            {therapist.age}{t('age_suffix')}
          </span>
          <span className="meta-item">
            <FiAward className="meta-icon" />
            {t('experience_years', { years: therapist.experience })}
          </span>
        </div>

        {(therapist.height || therapist.weight) && (
          <div className="therapist-body-info">
            {therapist.height && (
              <span className="body-item">{t('height_label')}: {therapist.height}cm</span>
            )}
            {therapist.weight && (
              <span className="body-item">{t('weight_label')}: {therapist.weight}kg</span>
            )}
          </div>
        )}

        {therapist.features && (
          <div className="therapist-features">
            <span className="features-tag">{localize(therapist.features)}</span>
          </div>
        )}

        <div className="therapist-specialties">
          {specialtyNames.map((name, i) => (
            <span key={i} className="specialty-tag">
              {name}
            </span>
          ))}
        </div>

        {showDetails && <p className="therapist-bio">{localize(therapist.bio)}</p>}
      </div>

      {selected && <div className="therapist-check">✓</div>}
    </div>
  );
}

export default TherapistCard;
